<template>
  <div>
    <div style="margin-top: 10px; margin-bottom: 10px; margin-left: 20px">
      <el-button @click="handleOpenAddCustomer()" :disabled="isAdmin">Add Customer</el-button>
      <el-button @click="exportCustomer()">Export</el-button>
    </div>
    <el-table :data="customers" :row-class-name="tableRowClassName">
      <el-table-column label="Customer">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{ scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column label="Secret">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{ scope.row.secret }}</span>
        </template>
      </el-table-column>
      <el-table-column label="Last Contact">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{ scope.row.lastContact }}</span>
        </template>
      </el-table-column>
      <el-table-column label="Contract Components" width="170">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{ scope.row.contractedComponents }}</span>
        </template>
      </el-table-column>
      <el-table-column label="Actual Components" width="160">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{ scope.row.reportedComponents }}</span>
        </template>
      </el-table-column>
      <el-table-column label="Active" width="100">
        <template slot-scope="scope">
          <i
            v-if="scope.row.active"
            class="el-icon-success"
            style="color: #13ce66; font-size: 20px"
          ></i>
          <i
            v-if="!scope.row.active"
            class="el-icon-error"
            style="color: #ff4949; font-size: 20px"
          ></i>
        </template>
      </el-table-column>
      <el-table-column label="Operations" width="100">
        <template slot-scope="scope">
          <el-button
            size="mini"
            icon="el-icon-edit"
            :disabled="isAdmin"
            circle
            @click="handleEditOpen(scope.row)"
          ></el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog :visible.sync="editDialogVisible" width="40%" :before-close="handleClose">
      <el-form ref="form" :model="form" label-width="160px">
        <el-form-item label="Customer Name">
          <el-input v-model="edit.name" />
        </el-form-item>
        <el-form-item label="Contract Components">
          <el-input-number v-model="edit.contractedComponents" :min="0"></el-input-number>
        </el-form-item>
        <el-form-item label="Actual Components">
          <span>{{ edit.reportedComponents }}</span>
        </el-form-item>
        <el-form-item label="Active">
          <el-switch v-model="edit.active"></el-switch>
        </el-form-item>
        <el-form-item label="Secret">
          <el-input v-model="edit.secret"></el-input>
          <el-tooltip content="Generate new token" placement="top">
            <el-button
              style="margin-left: 10px"
              size="mini"
              circle
              icon="el-icon-refresh"
              @click="edit.secret = ''"
            ></el-button>
          </el-tooltip>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="loadData()">Cancel</el-button>
        <el-button type="primary" @click="handleNewEdit()">Confirm</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="Delete Customer"
      :visible.sync="deleteDialogVisible"
      width="40%"
      :before-close="handleClose"
    >
      <span>Do you really want do delete the Customer "{{ edit.customer }}"?</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteDialogVisible = false">Cancel</el-button>
        <el-button type="primary" @click="handleDelete(edit.id)">Confirm</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<style>
.el-table .danger {
  background: #ff9999;
}

.el-table .warning {
  background: #ffe6b3;
}
</style>

<script>
import { AddCustomer, LoadCustomer, EditCustomer, getUserRole, TempTokenId } from "../api.js";

export default {
  name: "Customer",
  props: {},
  data: function() {
    return {
      customers: [],
      editDialogVisible: false,
      deleteDialogVisible: false,
      edit: {},
      isAdmin: false
    };
  },
  methods: {
    handleEditOpen(customer) {
      this.edit = Object.assign({}, customer);
      this.editDialogVisible = true;
    },
    handleDeleteOpen(customer) {
      this.edit = Object.assign({}, customer);
      this.deleteDialogVisible = true;
    },
    handleOpenAddCustomer() {
      this.edit = { reportedComponents: 0, active: true, contractedComponents: 0, name: "" };
      this.editDialogVisible = true;
    },
    async handleNewEdit() {
      this.editDialogVisible = false;
      if (this.edit.id) {
        await EditCustomer(this.edit);
      } else {
        await AddCustomer(this.edit);
      }
      this.loadData();
    },
    async handleDelete(customerId) {
      this.deleteDialogVisible = false;
      // await DeleteCustomer(customerId);
      this.loadData();
    },
    async loadData() {
      this.editDialogVisible = false;

      this.customers = await LoadCustomer();
    },
    handleClose: function() {
      this.editDialogVisible = false;
      this.deleteDialogVisible = false;
    },
    tableRowClassName: function({ row, rowIndex }) {
      if (row.reportedComponents > row.contractedComponents) {
        return "danger";
      } else if (row.reportedComponents > row.contractedComponents * 0.9) {
        return "warning";
      }

      return "";
    },
    async exportCustomer() {
      const id = await TempTokenId();

      window.location = `/api/customer/export?access_token=${id}`;
    },
    getRole() {
      this.isAdmin = getUserRole() === "Admin";
    }
  },
  mounted() {
    this.loadData();
    this.getRole();
  }
};
</script>

